import {
  computed,
  inject,
  onUnmounted,
  provide,
  ref
} from "@nuxtjs/composition-api";
const tabsInjectionKey = Symbol("tabs");
function scrollIntoTabNav(target) {
  target.scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "center"
  });
}
function useTabs() {
  const tabs = ref([]);
  const activeTab = ref();
  provide(tabsInjectionKey, {
    tabs,
    activeTab
  });
  const setActiveTab = (tabName, target) => {
    activeTab.value = tabName;
    if (target)
      scrollIntoTabNav(target);
  };
  return {
    tabs,
    activeTab,
    setActiveTab
  };
}
function useTab(tabItem) {
  const { tabs, activeTab } = inject(tabsInjectionKey);
  if (!tabs.value.length)
    activeTab.value = tabItem.value.name;
  tabs.value.push(tabItem);
  const isActive = computed(() => activeTab.value === tabItem.value.name);
  onUnmounted(() => {
    tabs.value = tabs.value.filter(
      (tab) => tab.value.name !== tabItem.value.name
    );
  });
  return {
    isActive
  };
}
export {
  useTab,
  useTabs
};
